'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLanguageOptions = exports.languageCodes = undefined;

var _langs = require('langs');

var _langs2 = _interopRequireDefault(_langs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var languages = [_langs2.default.where('1', 'de'), _langs2.default.where('1', 'en'), _langs2.default.where('1', 'fr'), _langs2.default.where('1', 'hi'), _langs2.default.where('1', 'nl'), _langs2.default.where('1', 'pl'), _langs2.default.where('1', 'it')];
var languageCodes = exports.languageCodes = languages.map(function (lang) {
  return lang['1'];
});

var getLanguageOptions = exports.getLanguageOptions = function getLanguageOptions(supportedLanguagesCodes) {
  return languages.map(function (lang) {
    return {
      label: lang.local,
      value: lang['1'],
      disabled: !supportedLanguagesCodes.includes(lang['1'])
    };
  });
};